import { render, staticRenderFns } from "./search-customer.vue?vue&type=template&id=51bd09d2&"
import script from "./search-customer.vue?vue&type=script&lang=js&"
export * from "./search-customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports